import React from 'react';
import { shape, number, bool } from 'prop-types';
import i18next from 'i18next';
import { useSelector } from 'react-redux';

import { TARGETS as orderTargets } from '~redux/Order/constants';
import Text from '~components/Text';

import styles from './styles.module.scss';

function StoreInfo({ deliveryInfo, hideTime }) {
  const futureOrder = useSelector((state) => state.order[orderTargets.FUTURE_ORDER]);

  return (
    <div className={`row space-between center full-width ${styles.storeInfo}`}>
      <div className={`row middle ${styles.cardContent} ${styles.addressContainer}`}>
        <i className={`icon-delivery_dining m-right-2 ${styles.deliveryIcon}`} />
        <Text className={`text-base ${styles.address}`}>
          {i18next.t('Delivery:from', { value: deliveryInfo.name })}
        </Text>
      </div>
      {!futureOrder && !hideTime && (
        <div className={`row middle ${styles.cardContent} ${styles.deliveryTimeContainer}`}>
          <i className={`icon-timer m-right-2 subtitle-small ${styles.timeIcon}`} />
          <Text className={`text-base ${styles.deliveryTime}`}>
            {i18next.t('Delivery:time', {
              time: deliveryInfo.deliveryWaitTime
            })}
          </Text>
        </div>
      )}
    </div>
  );
}

StoreInfo.propTypes = {
  deliveryInfo: shape({
    deliveryWaitTime: number
  }),
  hideTime: bool
};

StoreInfo.defaultProps = {
  hideTime: false
};

export default StoreInfo;
